import styled from 'styled-components';
import { media } from '@/styles/Qtheme.ts';
import { MobileCalVW, TabletCalVW } from '@utils/CalVW.tsx';

export const CompetitionHistoryContainer = styled.div`
  width: 1200px;

  @media ${media.desktop} {
    width: ${TabletCalVW(900)};
  }

  @media ${media.mobile} {
    width: 100%;
    padding: 0 ${MobileCalVW(16)};
  }
`;

export const CompetitionSection = styled.div`
  margin-top: 20px;

  h3 {
    font-family: 'Pretendard', sans-serif;
    font-weight: 600;
    font-size: 18px;
    color: ${({ theme }) => theme.text};
    margin-bottom: 16px;
  }

  @media ${media.mobile} {
    h3 {
      font-size: ${MobileCalVW(16)};
    }
  }
`;

export const CompetitionCard = styled.div`
  background-color: ${({ theme }) => theme.COLORS.PrimaryBg};
  border: 1px solid ${({ theme }) => theme.COLORS.PrimaryBorder};
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 16px;
  transition: all 0.2s ease;
  cursor: pointer;

  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transform: translateY(-2px);
    border-color: #007aff;
  }

  @media ${media.mobile} {
    padding: ${MobileCalVW(16)};
    margin-bottom: ${MobileCalVW(12)};
  }
`;

export const CompetitionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  gap: 12px;

  @media ${media.mobile} {
    flex-direction: column;
    align-items: flex-start;
    gap: ${MobileCalVW(8)};
  }
`;

export const CompetitionTitle = styled.h4`
  font-family: 'Pretendard', sans-serif;
  font-weight: 600;
  font-size: 16px;
  color: ${({ theme }) => theme.text};
  margin: 0;
  flex: 1;

  @media ${media.mobile} {
    font-size: ${MobileCalVW(14)};
  }
`;

export const CompetitionStatus = styled.span<{ color: string }>`
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  color: ${({ color }) => color};
  background-color: ${({ color }) => `${color}1A`}; // 10% opacity
  white-space: nowrap;

  @media ${media.mobile} {
    font-size: ${MobileCalVW(11)};
    padding: ${MobileCalVW(4)} ${MobileCalVW(10)};
  }
`;

export const CompetitionInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  @media ${media.mobile} {
    gap: ${MobileCalVW(6)};
  }
`;

export const InfoRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  @media ${media.mobile} {
    gap: ${MobileCalVW(6)};
  }
`;

export const InfoLabel = styled.span`
  font-family: 'Pretendard', sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: ${({ theme }) => theme.textSecondary || theme.text};
  min-width: 80px;

  @media ${media.mobile} {
    font-size: ${MobileCalVW(12)};
    min-width: ${MobileCalVW(70)};
  }
`;

export const InfoValue = styled.span`
  font-family: 'Pretendard', sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: ${({ theme }) => theme.text};

  @media ${media.mobile} {
    font-size: ${MobileCalVW(12)};
  }
`;

export const EmptyState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
  color: ${({ theme }) => theme.textSecondary || theme.text};
  font-size: 14px;
  background-color: ${({ theme }) => theme.COLORS.PrimaryBg};
  border: 1px dashed ${({ theme }) => theme.COLORS.PrimaryBorder};
  border-radius: 12px;

  @media ${media.mobile} {
    padding: ${MobileCalVW(40)} ${MobileCalVW(16)};
    font-size: ${MobileCalVW(13)};
  }
`;

export const LoadingState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
  color: ${({ theme }) => theme.text};
  font-size: 14px;

  @media ${media.mobile} {
    padding: ${MobileCalVW(40)} ${MobileCalVW(16)};
    font-size: ${MobileCalVW(13)};
  }
`;
